<sbnb-progress-stepper
  *ngIf="directDashboardService.steps?.length >= 2"
  [selectedIndex]="0"
  class="w-full max-w-[820px] justify-self-center block mb-8">
  <cdk-step *ngFor="let step of directDashboardService.steps" [label]="step.label" [completed]="false"></cdk-step>
</sbnb-progress-stepper>

<div class="grid gap-4 grid-cols-[1fr_auto] items-center border border-smoke p-6">
  <ng-container [ngSwitch]="directDashboardService.steps[0].id">
    <ng-container *ngSwitchCase="'create-site'">
      <div class="grid gap-2">
        <h3 class="m-0">Let's start by creating your website.</h3>
        <p class="m-0">
          Create a site that showcases your brand in minutes or start taking bookings from your own self-hosted site.
        </p>
      </div>
      <sbnb-button (click)="addSite()">Create a site</sbnb-button>
    </ng-container>

    <ng-container *ngSwitchCase="'add-payout'">
      <div class="grid gap-2">
        <h3 class="m-0">Congrats, you created your site! Now tell us how you want to get paid.</h3>
        <p class="m-0">Connect your bank account to publish your site and start getting paid for direct bookings.</p>
      </div>
      <sbnb-button (click)="addPayoutMethod()">Add a payout method</sbnb-button>
    </ng-container>

    <ng-container *ngSwitchCase="'taxes'">
      <div class="grid gap-2">
        <h3 class="m-0">One more step, let’s review your taxes.</h3>
        <p class="m-0">Tell us how to calculate sales and lodging taxes for your properties.</p>
      </div>
      <sbnb-button (click)="setupTaxes()">Set up taxes</sbnb-button>
    </ng-container>

    <ng-container *ngSwitchCase="'activate-direct'">
      <div class="grid gap-2">
        <h3 class="m-0">You’re ready to start taking direct bookings!</h3>
        <p class="m-0">Before you can publish your site, you need to activate your Direct subscription.</p>
      </div>
      <sbnb-button (click)="activateDirect()">Activate Direct</sbnb-button>
    </ng-container>

    <ng-container *ngSwitchCase="'publish-site'">
      <div class="grid gap-2">
        <h3 class="m-0">You’re ready to start taking direct bookings!</h3>
        <p class="m-0">All you have to do is publish your site.</p>
      </div>
      <sbnb-button (click)="publishSite()">Publish my site</sbnb-button>
    </ng-container>

    <ng-container *ngSwitchCase="'no-properties'">
      <div class="grid gap-2">
        <h3 class="m-0">You’re ready to start taking direct bookings!</h3>
        <p class="m-0">Enable widgets for your properties and add them to your self-hosted site .</p>
      </div>
      <sbnb-button (click)="selectProperties()">Select properties</sbnb-button>
    </ng-container>
  </ng-container>
</div>
